import { useSelector } from "react-redux";
import styles from "./ContentManagementCard.module.css";

const DashboardContentManagement = (props) => {
  const { language, translations } = useSelector((state) => state.language);
  return (
    <div className={styles.grid}>
      {props.cardsData.map((card) => (
        <div key={card.id} className={styles.card}>
          <div className={styles.iconWrapper}>
            <img src={card.icon} alt={card.title} />
          </div>
          <h3 className={styles.title}>{card.title}</h3>
          <div className={styles.actions}>
            <button onClick={() => props.handleAdd(card.id)}>
              {translations.labels.add}
            </button>
            <button onClick={() => props.handleView(card.id)}>
              {translations.labels.view}

            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardContentManagement;
